import {Component} from "@angular/core";
import {Router, RouterLink} from '@angular/router';
import {LoginService} from '../../../app-core/service/login.service';
import {Modulo, Usuario} from '../../../app-core/model/cadastros/usuario.model';
import {DeprecatedSharedUtilsModule} from '../../../app-core/utils/deprecated-shared-utils-module';
import {UiModule} from '../../../app-core/utils/ui/ui.module';
import {ShapeUploadComponent} from '../components/modals/shape-upload/shape-upload.component';
@Component({
    selector: "home",
    templateUrl: "home.component.html",
    imports: [
        RouterLink,
        DeprecatedSharedUtilsModule,
        UiModule,
        ShapeUploadComponent,
    ],
    styleUrls: ['./home.component.scss']
})

export class HomeComponent {

    usuarioLogado: Usuario;
    private _menus;

    get menus() {
        return this._menus.filter((menu) => menu.enabled);
    }

    someMenuEnabled() {
        return this._menus.filter((menu) => menu.enabled)?.length > 0;
    }

    private hasModulo(modulo: string): boolean {
        return this.usuarioLogado?.modulos?.includes(modulo);
    }

    protected hasRole(role: string) {
        return this.usuarioLogado?.roles?.includes(role);
    }

    constructor(private loginService: LoginService) {
        this.usuarioLogado = this.loginService.getUser();

        let i = 0;

        this._menus = [
            {
                id: i++,
                title: "Análise Geral",
                icon: "iconpdsa-geo icon-pdsa-map-geral lg",
                subTitle: "Cadastrar, editar e visualizar",
                link: "../analise-geral",
                enabled: false
            },
            {
                id: i++,
                title: "Análise Sanitária",
                icon: "iconpdsa-geo icon-pdsa-foco lg",
                subTitle: "Cadastrar, editar e visualizar",
                link: "../sanitary-analysis",
                enabled: (this.hasRole('admin') || this.hasModulo(Modulo.SANITARY_ANALYSIS))
            },
            {
                id: i++,
                title: "Resposta Evento Sanitário",
                icon: "iconpdsa-geo icon-pdsa-shield-checked lg",
                subTitle: "Cadastrar, editar e visualizar",
                link: "../event-response",
                enabled: (this.hasRole('admin') || this.hasModulo(Modulo.SANITARY_EVENT_RESPONSE))
            },
            {
                id: i++,
                title: "Ações no Evento Sanitário",
                icon: "iconpdsa-geo icon-pdsa-foco-checklist lg",
                subTitle: "Preencher, editar e visualizar",
                link: "../focus-actions",
                enabled: (this.hasRole('admin') || this.hasModulo(Modulo.SANITARY_EVENT_ACTIONS))
            },
            {
                id: i++,
                title: "Movimentações",
                icon: "iconpdsa-geo icon-pdsa-foco-checklist lg",
                subTitle: "Visualizar e Cadastrar movimentações",
                link: "../upload-movimentacoes",
                enabled: (this.hasRole('admin') || this.hasModulo(Modulo.IMPORT))
            },
            {
                id: i++,
                title: "Tarefas Assíncronas",
                icon: "iconpdsa-geo icon-pdsa-foco-checklist lg",
                subTitle: "Visualizar tarefas assíncronas",
                link: "../async-tasks",
                enabled: (this.hasRole('admin') || this.hasModulo(Modulo.IMPORT))
            },
            {
                id: i++,
                title: "Espalhamento de doença",
                subTitle: "Cadastrar, editar e visualizar",
                icon: "iconpdsa-geo flaticon2-map",
                link: "../spread-disease",
                enabled: (this.hasRole('admin') || this.hasModulo(Modulo.SPREAD_DISEASE))
            },
            {
                id: i++,
                title: "Usuários",
                icon: "fa fa-user",
                subTitle: "Cadastrar, editar e visualizar",
                link: "../user",
                enabled: this.hasRole('admin')
            },
            {
                id: i++,
                title: "Estabelecimentos",
                icon: "fa fa-building lg",
                subTitle: "Cadastrar, editar e visualizar",
                link: "../premise",
                enabled: (this.hasRole('admin') || this.hasModulo(Modulo.PREMISES))
            }
        ];
    }
}
